import { useEffect, useState } from "react";

export default function CallSummaryCard({
  icon,
  label,
  value,
  duration,
  variant = "inbound",
  animate = true,
}) {
  const normalizedValue = value == null || value === "" ? 0 : value;

  const [displayValue, setDisplayValue] = useState(
    animate && typeof normalizedValue === "number" ? 0 : normalizedValue
  );

  useEffect(() => {
    if (!animate || typeof normalizedValue !== "number") {
      setDisplayValue(normalizedValue);
      return;
    }

    let frameId = 0;
    const start = performance.now();
    const durationMs = 800;

    const tick = (now) => {
      const progress = Math.min((now - start) / durationMs, 1);
      const eased = 1 - (1 - progress) ** 3;
      setDisplayValue(Math.round(normalizedValue * eased));

      if (progress < 1) {
        frameId = window.requestAnimationFrame(tick);
      }
    };

    frameId = window.requestAnimationFrame(tick);

    return () => window.cancelAnimationFrame(frameId);
  }, [animate, normalizedValue]);

  const renderedValue =
    typeof displayValue === "number"
      ? displayValue.toLocaleString()
      : displayValue ?? "--";

  return (
    <div className={`ebhc-call-card ebhc-call-card--${variant}`.trim()}>
      <div className="ebhc-call-card__label">
        <span className="ebhc-call-card__icon">{icon}</span>
        {label}
      </div>

      <div className="ebhc-call-card__value">{renderedValue}</div>

      <div className="ebhc-call-card__footer">
        <div className="ebhc-call-card__footer-value">
          {duration || "—"}
        </div>
      </div>
    </div>
  );
}